import { Config } from '@app/web-components';

// TODO: Add apiT3 URLS for dev test and prod
type AppConfig = {
  domain: string[];
  auth: {
    clientId: string;
    authority: string;
    redirectUri: string;
  };
  sso: {
    scopes: string[];
  };
  apiMain: string;
  app: Config.Config;
  environment?: string;
  showEnvironment?: boolean;
};

export const CONFIG: AppConfig[] = [
  {
    domain: ['localhost', 'localhost:4201', 'localhost:4202'],
    auth: {
      clientId: '5a0600c4-c582-4397-bb3e-49bfa96fbb46',
      authority: 'https://login.microsoftonline.com/46c98d88-e344-4ed4-8496-4ed7712e255d',
      redirectUri: 'http://localhost:4202/',
    },
    sso: {
      scopes: ['api://5a0600c4-c582-4397-bb3e-49bfa96fbb46/user_impersonation'],
    },
    apiMain: 'http://localhost:3333/api/external',
    app: {
      promoteUrl: 'https://saaf-dev.intel.com',
    },
    environment: 'Local',
    showEnvironment: true,
  },
  {
    domain: ['saaf-t3-external-dev.intel.com'],
    auth: {
      clientId: '5a0600c4-c582-4397-bb3e-49bfa96fbb46',
      authority: 'https://login.microsoftonline.com/46c98d88-e344-4ed4-8496-4ed7712e255d',
      redirectUri: 'https://saaf-t3-external-dev.intel.com/',
    },
    sso: {
      scopes: ['api://5a0600c4-c582-4397-bb3e-49bfa96fbb46/user_impersonation'],
    },
    apiMain: 'https://saaf-dev-api.intel.com/api/external',
    app: {
      promoteUrl: 'https://saaf-test.intel.com',
    },
    environment: 'Development',
    showEnvironment: true,
  },
  {
    domain: ['enaa-test.intel.com'],
    auth: {
      clientId: '5a0600c4-c582-4397-bb3e-49bfa96fbb46',
      authority: 'https://login.microsoftonline.com/46c98d88-e344-4ed4-8496-4ed7712e255d',
      redirectUri: 'https://enaa-test.intel.com/',
    },
    sso: {
      scopes: ['api://5a0600c4-c582-4397-bb3e-49bfa96fbb46/user_impersonation'],
    },
    apiMain: 'https://apis-stage.intel.com/saafthreeway/v1/external',
    app: {
      promoteUrl: 'https://saaf.intel.com',
    },
    environment: 'Test',
    showEnvironment: false,
  },
  {
    domain: ['enaa.intel.com'],
    auth: {
      clientId: 'ab3541ef-8d32-4472-9bc0-99a8ab62b84d',
      authority: 'https://login.microsoftonline.com/46c98d88-e344-4ed4-8496-4ed7712e255d',
      redirectUri: 'https://enaa.intel.com/',
    },
    sso: {
      scopes: ['api://ab3541ef-8d32-4472-9bc0-99a8ab62b84d/user_impersonation'],
    },
    apiMain: 'https://apis.intel.com/saafthreeway/v1/external',
    app: {},
  },
];

export const getConfig = () => {
  const domain = window.location.host;
  const config = CONFIG.find((x) => x.domain.some((y) => y.toLowerCase() === domain.toLowerCase()));

  if (!config) {
    throw new Error(`No configuration found for domain '${domain}'.`);
  }

  return config;
};
